import React from 'react';

interface StatusDoneProps {
  FilteGroup: any[];
  reportsData?: any;
}

export const StatusDone = ({ FilteGroup, reportsData }: StatusDoneProps) => {
  const getFactoryStatus = (factoryId: string): string => {
    if (reportsData?.data?.[factoryId]?.status) {
      return reportsData.data[factoryId].status;
    }
    return 'Не начато';
  };

  const factoryStatuses: string[] = FilteGroup.map((factory) =>
    getFactoryStatus(factory.id || factory.ID)
  );

  const completed = factoryStatuses.filter((status) => status === 'Завершено').length;
  const inProgress = factoryStatuses.filter((status) => status === 'В процессе').length;
  const notStarted = factoryStatuses.filter((status) => status === 'Не начато').length;
  const total = factoryStatuses.length;

  const hasData = total > 0 && FilteGroup.length > 0;

  const completedPercent = hasData ? Math.round((completed / total) * 100) : 0;
  const inProgressPercent = hasData ? Math.round((inProgress / total) * 100) : 0;
  const notStartedPercent = hasData ? Math.round((notStarted / total) * 100) : 100;

  const statusColor = {
    notStart: 'w-3 h-3 rounded bg-[#8899A8]',
    inProcess: 'w-3 h-3 rounded bg-[#F2A900]',
    completed: 'w-3 h-3 rounded bg-[#22AD5C]',
  };

  return (
    <div className='mt-4 mb-8 bg-white rounded-lg p-4'>
      <div className='flex h-7 rounded-full overflow-hidden'>
        <div 
          className='bg-[#22AD5C] transition-all duration-300 flex items-center justify-center text-white text-sm font-normal' 
          style={{ width: `${completedPercent}%` }}
        >
          {completedPercent > 1 && `${completedPercent}%`}
        </div>
        <div 
          className='bg-[#F2A900] transition-all duration-300 flex items-center justify-center text-white text-sm font-normal' 
          style={{ width: `${inProgressPercent}%` }}
        >
          {inProgressPercent > 1 && `${inProgressPercent}%`}
        </div>
        <div 
          className='bg-[#8899A8] transition-all duration-300 flex items-center justify-center text-white text-sm font-normal' 
          style={{ width: `${notStartedPercent}%` }}
        >
          {notStartedPercent > 1 && `${notStartedPercent}%`}
        </div>
      </div>
      <div className='flex justify-between mt-2 text-sm w-[40%] mx-auto'>
        <div className='flex items-center gap-2'>
          <div className={statusColor.completed} />
          <span className='text-sm font-normal text-primary'>Завершено</span>
        </div>
        <div className='flex items-center gap-2'>
          <div className={statusColor.inProcess} />
          <span className='text-sm font-normal text-primary'>В процессе</span>
        </div>
        <div className='flex items-center gap-2'>
          <div className={statusColor.notStart} />
          <span className='text-sm font-normal text-primary'>Не начато</span>
        </div>
      </div>
    </div>
  );
};